import React from 'react';
import Close from '../../assets/images/icons/close.svg';
import { useAppTranslation } from '../../i18n';

interface ModalCloseProps {
	onClose(): void;
}

const ModalClose = ({ onClose }: ModalCloseProps) => {
	const { t } = useAppTranslation();

	return (
		<div className="modal-actions">
			<button type="button" className="icon-button modal-actions-close" onClick={onClose} aria-label={t('a11y.close')}>
				<img className="modal-close" src={Close} alt="" aria-hidden="true" />
			</button>
		</div>
	);
};

export default ModalClose;
